import {MUI} from '@verihubs/pandora';
import {Fragment} from 'react';
import {useLocation} from 'react-router-dom';
import {useViewModel} from './ViewModel';

const {Button, Dialog, DialogTitle, DialogActions, DialogContentText, DialogContent} = MUI;

const UnsubscribeVerificationResponse = () => {
  const {data, method} = useViewModel();
  const urlParams = useLocation().search;
  const email = new URLSearchParams(urlParams).get('email');
  return (
    <Fragment>
      <Dialog
        maxWidth="sm"
        fullWidth={true}
        open={data.modalState}
        onClose={method.handleCloseModal}
      >
        <DialogTitle>Unsubscribe</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Click the confirm button to unsubscribe {email} from all Verihubs updates.
          </DialogContentText>
          <DialogActions sx={{bgcolor: 'grey'}}>
            <Button onClick={method.handleCloseModal}>CANCEL</Button>
            <Button onClick={method.onUnsubscribe} variant="contained" color="error">
              UNSUBSCRIBE FROM UPDATES
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default UnsubscribeVerificationResponse;
